import abopsly from 'array-buffer:opsly-web-font/font/opsly.woff2'

const opsly = new FontFace('opsly', abopsly)

opsly.load().then(function (font) {
    document.fonts.add(font)
}).catch(function (err) {
    clonsole.error(err)
})